import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	loadIndividualConsultationFormResponses, createIndividualConsultationFormResponse, deleteIndividualConsultationFormResponse,
	INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_FAILURE
} from './actions';
import List from './List';
import NewFormDialog from './NewFormDialog';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import { Button, SplitButton, MenuItem } from 'react-bootstrap';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';

class IndividualConsultationFormResponses extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleAddFormResponse = this.handleAddFormResponse.bind(this);
		this.handleDeleteFormResponse = this.handleDeleteFormResponse.bind(this);
		this.showNewFormDialog = this.showNewFormDialog.bind(this);
		this.hideNewFormDialog = this.hideNewFormDialog.bind(this);

		this.state = { showNewFormDialog: false };
	}

	componentDidMount() {
		this.reloadData();
	}

	handleListEvent(listPagination) {
		const paymentId = this.props.paymentId;
		this.props.loadData({ paymentId, excludeNew: false, ...listPagination });
	}

	reloadData() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const paymentId = this.props.paymentId;
		this.props.loadData({ paymentId, excludeNew: false, sortKey, sortDirection, pageNumber, pageSize });
	}

	showNewFormDialog() {
		this.setState({ showNewFormDialog: true });
	}

	hideNewFormDialog() {
		this.setState({ showNewFormDialog: false });
	}

	handleAddFormResponse({ formId, date }) {
		const { createFormResponse, paymentId } = this.props;
		const onSuccess = () => {
			this.hideNewFormDialog();
			this.reloadData();
		};
		createFormResponse({ paymentId, formId, date }, onSuccess);
	}

	handleDeleteFormResponse(id) {
		this.props.deleteFormResponse(id, () => this.reloadData());
	}

	render() {
		const { isReadonly, data, pagination, forms, allowDeleteCompleted, t, ...rest } = this.props;

		return <div>
			{!isReadonly && forms && forms.length > 0 && <Button bsStyle='success' style={{marginBottom: '10px'}} onClick={this.showNewFormDialog}>{t('Common_New')}</Button>}
			<List onFetchData={this.handleListEvent} data={data} onDelete={this.handleDeleteFormResponse} allowDeleteCompleted={allowDeleteCompleted} {...pagination} {...rest} />
			<NewFormDialog forms={forms && forms.map(x => ({ ...x, displayName: t(`AssessmentForm_Consultation_${x.name}`) }))}
				show={this.state.showNewFormDialog}
				onConfirm={this.handleAddFormResponse}
				onCancel={this.hideNewFormDialog}
				block={INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_REQUEST}
				unblock={[INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_FAILURE]}
			/>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { individualConsultationFormResponses },
		lookups: { individualConsultationForms },
		auth: { currentUser }
	} = state;

	const individualConsultationFormResponsesPagination = pagination.individualConsultationFormResponses[ownProps.paymentId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: individualConsultationFormResponsesPagination.ids.map(id => individualConsultationFormResponses[id]),
		pagination: individualConsultationFormResponsesPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationDocuments'),
		forms: individualConsultationForms && individualConsultationForms.filter(x => x.isTeacherForm),
		allowDeleteCompleted: authUtils.hasPermission(currentUser, 'UndoCompletedForms')
	};
};

IndividualConsultationFormResponses.propTypes = {
	paymentId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadIndividualConsultationFormResponses,
	createFormResponse: createIndividualConsultationFormResponse,
	deleteFormResponse: deleteIndividualConsultationFormResponse
})(withTranslation()(IndividualConsultationFormResponses));